import { Nullable } from 'global';
import { useSelector } from 'react-redux';
import { Table } from 'components/shared/Table';
import { DealerManagementPartnerLink } from 'modules/aftermarket/partner/types';
import { createTableColumns } from './tableConfig';

interface Props {
  loading?: boolean;
  tableData?: DealerManagementPartnerLink[];
  onRowClick?: (partnerLinkId: Nullable<string> | undefined) => void;
  handleOpenIntegrationSettingsDialog: (data: { partnerLink: DealerManagementPartnerLink }) => void;
}

export const DealerManagementTable = ({
  loading,
  onRowClick,
  tableData = [],
  handleOpenIntegrationSettingsDialog,
}: Props) => {
  const isIntegrationAdminAccount = useSelector((state: any) => state.aftermarketPartner.isIntegrationAdminAccount);

  const columns = createTableColumns(tableData, handleOpenIntegrationSettingsDialog, isIntegrationAdminAccount);

  return (
    <Table<DealerManagementPartnerLink>
      tableData={tableData}
      columns={columns}
      loading={loading}
      onRowClick={row => onRowClick?.(row.partnerLinkId)}
      paginationOptions={{ pageSize: 25 }}
    />
  );
};
